import { PaymentTypeEnum } from 'graphql/main/queries';

export interface PaymentTypeForm {
  paymentType?: string;
}

export const paymentTypeFormDefaultValues: PaymentTypeForm = {
  paymentType: PaymentTypeEnum.NOW,
};
